import { FAQ_SECTIONS, FAQ_SECTIONS_BY_KEY } from "../data/faqs";
import type { FaqSection, Key, KeyList } from "../types";

type GetFaqSectionsOptions = {
  limit?: number;
};

export function getFaqSections(
  keys?: KeyList,
  options?: GetFaqSectionsOptions,
): FaqSection[] {
  if (!keys) {
    return FAQ_SECTIONS.slice(0, options?.limit);
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list
    .map(key => FAQ_SECTIONS_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}

export function getFaqSection(key: Key): FaqSection {
  return FAQ_SECTIONS_BY_KEY[key];
}
